const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "user":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "user",
    reducer: reducer,
};

export default data;